module.exports = __webpack_public_path__ + "static/media/DonkeyKong.9be32be1.png";